import { ExpandableCard } from '@lmig/lmds-react-card';
import { Heading } from '@lmig/lmds-react-typography';
import { IAgencyMetrics } from 'Foundation/Agency/IAgencyMetrics';
import { ISimpleInputTableItem, SimpleInputTable } from 'Foundation/Common/SimpleInputTable';
import { SimpleTable } from 'Foundation/Common/SimpleTable';
import { useAgencyMetrics } from 'Foundation/Agency/AgencyMetricsContext';
import { useUserData } from 'Foundation/User/UserContext';
import { useEffect, useState } from 'react';

const convertAgencyMetricsToTableData = (agencyMetrics: IAgencyMetrics | null | undefined): ISimpleInputTableItem[] => {
  if (!agencyMetrics) {
    return [];
  }
  return Object.entries(agencyMetrics)
    .map(([key, value]) => ({
      name: key,
      value: String(value),
    }))
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter((item) => item.name !== 'default');
};

const convertTableDataToAgencyMetrics = (tableData: ISimpleInputTableItem[]): IAgencyMetrics => {
  let newAgencyMetrics = {} as IAgencyMetrics;

  tableData.forEach((item) => {
    newAgencyMetrics[item.name as keyof IAgencyMetrics] = item.value as string;
  });

  return newAgencyMetrics;
};

export function UserInfoAgencyMetrics() {
  const { userData } = useUserData();
  const { updateAgencyMetrics, agencyMetrics, getAgencyMetrics } = useAgencyMetrics();
  const [tableData, setTableData] = useState<ISimpleInputTableItem[]>(convertAgencyMetricsToTableData(agencyMetrics));

  useEffect(() => {
    const newAgencyMetricsValue = convertAgencyMetricsToTableData(agencyMetrics);
    if (JSON.stringify(tableData) !== JSON.stringify(newAgencyMetricsValue)) {
      setTableData(newAgencyMetricsValue);
    }
  }, [agencyMetrics]);

  const triggerUpdateAgencyMetricsSync = (tableData: ISimpleInputTableItem[]) => {
    updateAgencyMetrics(convertTableDataToAgencyMetrics(tableData));
  };

  return userData ? (
    <ExpandableCard
    defaultExpanded={false}
      cardTitle={
        <Heading type="h4-light">
          Agency Metrics{' '}
          {!userData.isAgent() && agencyMetrics?.SUBSTAT && (
            <span style={{ color: 'blue' }}>({agencyMetrics?.SUBSTAT})</span>
          )}
        </Heading>
      }
    >
      <div className="container">
        {userData.isMockingAgent ? (
          <SimpleInputTable
            tableObject={tableData}
            onSubmit={triggerUpdateAgencyMetricsSync}
            onReset={() => getAgencyMetrics(true)}
            disabledFields={['OWNER_MASTER_SAFECO_AGENCY_CD', 'SUBSTAT']}
          />
        ) : (
          <SimpleTable tableObject={tableData} nameProp="name" valueProp="value" />
        )}
      </div>
    </ExpandableCard>
  ) : (
    <></>
  );
}